export default "__VITE_ASSET__b7fd5b68__"